/**
 * @file    index.js
 * @author  Daniel Naftzger
 * @created 2026-02-18
 * @updated 2026-02-26
 *
 * @description
 * Application entrypoint. Mounts the root React component into the DOM.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './pages/home/home.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Home />
  
);
